// import 'bootstrap-tourist';
import Shepherd from 'shepherd.js';
window.Shepherd = Shepherd
export default () => {}
/*
export default () => {
    window.tour = new Shepherd.Tour({
        useModalOverlay: true,
        defaultStepOptions: {
            classes: 'shadow-md bg-purple-dark',
            scrollTo: true,
        },
    })

    window.tour.addSteps([
        {
            id: 0,
            attachTo: {
                element: ".sidebar-contacts .sidebar-contact:first-child",
                on: 'auto'
            },
            title: "Component title",
            text: "In this section you will be able to…",
            buttons: [
                {
                    text: 'Next',
                    action: tour.next
                }
            ]
        },
        {
            id: 1,
            attachTo: {
                element: ".normal-cards .card:nth-child(5)",
                on: 'auto'
            },
            buttons: [
                {
                    text: 'Prev',
                    action: window.tour.prev
                },
                {
                    text: 'Next',
                    action: window.tour.next
                }
            ],
            title: "Component title",
            text: "In this section you will be able to…lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus ."
        },
        {
            id: 2,
            attachTo: {
                element: ".card.card--contract.card--no-contracts",
                on: 'auto'
            },
            buttons: [
                {
                    text: 'Prev',
                    action: window.tour.prev
                },
                {
                    text: 'End',
                    action: window.tour.next
                }
            ],
            title: "Component title",
            text: "In this section you will be able to…lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus ."
        }
    ])

    $('.start-tour').click(function () {
        window.tour.start();
    })
}


export default () => {
    window.tour = new Tour({
        framework: 'bootstrap4',
        showProgressBar: false,
        backdrop: true,
        template: `
        <div class="popover" role="tooltip">
            <div class="arrow"></div>
            <h3 class="popover-header"></h3>
            <div class="popover-body"></div>
            <div class="popover-navigation">
                <div class="btn-group">
                    <button class="btn btn-link" data-role="prev">
                        Previous
                    </button>
                    <button class="btn btn-link" data-role="next">
                     <svg class="icon svg-angle-right-dims" focusable="false" role="presentation">
                        <use xlink:href="http://localhost:9080/o/blm-customer-portal-theme/images/icons.svg#angle-right"></use>
                     </svg>
                        Next
                    </button>
                    <button class="btn btn-link" data-role="pause-resume" data-pause-text="Pause" data-resume-text="Resume">Pause</button>
                </div>
                <button class="btn btn-link" data-role="end">
                    End Tour
                </button>
            </div>
        </div>
        `,
        steps: [
            {
                element: "#tour-test-1",
                title: "Component title",
                content: "In this section you will be able to…lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus ."
            },
            {
                element: "#portlet_it_intesys_blm_gas_portlets_SoftwarePreviewListPortlet_INSTANCE_alvr .swiper-button-next",
                title: "Component title",
                content: "In this section you will be able to…lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus ."
            },
            {
                element: "#portlet_it_intesys_blm_serviceteams_portlets_ServiceTeamsPortlet",
                title: "Component title",
                content: "In this section you will be able to…lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus ."
            }
        ]});

    $('.start-tour').click(function () {
        window.tour.restart();
    })
}*/
